import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
export default {
    requestValidateNewDriver(driver) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.REQUEST_VALIDATE_NEW_DRIVER,
            driver,
        });
    },
    hideForm() {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.HIDE_ADD_DRIVER_FORM,
        });
    },
    showForm() {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.SHOW_ADD_DRIVER_FORM,
        });
    },
};
